function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path-159496334374050000",
  d: "M2.19231,0c-1.20463,0 -2.19231,1.00611 -2.19231,2.23321v11.91044c0,1.2271 0.98768,2.23321 2.19231,2.23321h7.08504l5.33804,3.62315v-3.62315h2.19231c1.20463,0 2.19231,-1.00611 2.19231,-2.23321v-11.91044c0,-1.2271 -0.98768,-2.23321 -2.19231,-2.23321zM2.19231,1.48881h14.61538c0.41106,0 0.73077,0.32568 0.73077,0.7444v11.91044c0,0.41873 -0.31971,0.7444 -0.73077,0.7444h-3.65385v2.33207l-3.43119,-2.33207h-7.53035c-0.41106,0 -0.73077,-0.32568 -0.73077,-0.7444v-11.91044c0,-0.41873 0.31971,-0.7444 0.73077,-0.7444zM4.38462,4.46642v1.48881h10.23077v-1.48881zM4.38462,7.44403v1.48881h10.23077v-1.48881zM4.38462,10.42164v1.48881h5.84615v-1.48881z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgReview = function SvgReview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 19.00001 20.00001",
    width: 19.00001,
    height: 20.00001,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(0, 90, 131)"
    },
    d: "M2.19231,0c-1.20463,0 -2.19231,1.00611 -2.19231,2.23321v11.91044c0,1.2271 0.98768,2.23321 2.19231,2.23321h7.08504l5.33804,3.62315v-3.62315h2.19231c1.20463,0 2.19231,-1.00611 2.19231,-2.23321v-11.91044c0,-1.2271 -0.98768,-2.23321 -2.19231,-2.23321zM2.19231,1.48881h14.61538c0.41106,0 0.73077,0.32568 0.73077,0.7444v11.91044c0,0.41873 -0.31971,0.7444 -0.73077,0.7444h-3.65385v2.33207l-3.43119,-2.33207h-7.53035c-0.41106,0 -0.73077,-0.32568 -0.73077,-0.7444v-11.91044c0,-0.41873 0.31971,-0.7444 0.73077,-0.7444zM4.38462,4.46642v1.48881h10.23077v-1.48881zM4.38462,7.44403v1.48881h10.23077v-1.48881zM4.38462,10.42164v1.48881h5.84615v-1.48881z",
    vectorEffect: "non-scaling-stroke"
  })), _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/review.d37aff51.svg";
export { ForwardRef as ReactComponent };